// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"NewSubDocForm_modalBody_3k81c","spinAround":"NewSubDocForm_spinAround_3dbDZ"};